module.exports = __webpack_public_path__ + "media/images/brand-assets/dark_1-9cc02b96998c24d46fe824ca0ac033c3.png";